import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { companiesConfig } from './companies/companiesConfig';

export const companyApis = {};
console.log("companyApis",companyApis);
for (const [companyKey, companyDetails] of Object.entries(companiesConfig)) {
  companyApis[companyKey] = balanceApi(companyDetails.reducerPath, companyDetails.apiKey);
}

function balanceApi(reducerPath, apiKey) {
    return createApi({
        reducerPath: reducerPath,
        baseQuery: fetchBaseQuery({
          baseUrl: 'https://publicapi.e-regnskab.dk/',
          prepareHeaders: (headers) => {
            headers.set('apiKey', apiKey);
          }
        }),
        endpoints(builder) {
          return {
            fetchBalance: builder.query({
              query: (arg) => {
                const { from, to } = arg;
                return {
                  url: 'Finance/Balance',
                  params: { from, to },
                  method: 'GET',
                };
              },
            }),
            fetchBudget: builder.query({
              query: (arg) => {
                const { budgetGroup, from, to } = arg;
                return {
                  url: 'Finance/Budget/Account',
                  params: { budgetGroup, from, to },
                  method: 'GET',
                };
              },
            }),
            fetchAppointments: builder.query({
              query: (arg) => {
                const { hnAppointmentId, from, to, open, } = arg;
                return {
                  url: 'Appointment/Standard',
                  params: { hnAppointmentId, open, from, to },
                  method: 'GET',
                };
              },
            }),
            fetchAppointmentStatistics: builder.query({
              query: (arg) => {
                const hnAppointmentId = arg;
                return {
                  url: `Appointment/Standard/Statistics${hnAppointmentId ? `/${hnAppointmentId}` : ''}`,
                  params: { hnAppointmentId },
                  method: 'GET',
                };
              },
            }),
          };
        }
      });
    }
